import type { GeoFormat } from "@rogoag/shared-ts";
import type { FeatureCollection } from "geojson";

export const INPUT_FILE_EXTENSIONS = ".zip,.shp,.geojson,.json,.kml,.kmz";
export const OUTPUT_FORMATS: readonly GeoFormat[] = ["SHP", "GeoJSON", "KML", "KMZ"] as const;

export interface LoadedFile {
	file: File;
	detectedFormat: GeoFormat;
	geojson: FeatureCollection;
	featureCount: number;
	geometryTypes: string[];
	propertyKeys: string[];
}

export type ConversionStatus = "idle" | "loading" | "converting" | "success" | "error";

export interface GeoFileConverterViewModel {
	// State
	loadedFiles: LoadedFile[];
	targetFormat: GeoFormat;
	status: ConversionStatus;
	errorMessage: string | null;
	fileInputRef: React.RefObject<HTMLInputElement | null>;

	// Actions
	handleFileSelect: (files: FileList | null) => Promise<void>;
	handleUploadClick: () => void;
	handleClear: () => void;
	handleRemoveFile: (index: number) => void;
	handleFormatChange: (format: GeoFormat) => void;
	handleConvert: () => Promise<void>;
}
